<template>
  <div>
    <v-row v-if="tableDisplay == 'offices'">
      <v-col cols="12" style="margin-top: -80px">
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn
              color="primary"
              dark
              rounded
              small
              class="mx-2"
              @click="office_dialog = true"
            >
              Create Office
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              dark
              rounded
              small
              class="mx-2"
              @click="bulkUserUpload = true"
            >
              Upload Offices
              <v-icon>mdi-upload</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="mb-4 px-3 mt-n2" v-if="selected.length > 0">
          <v-app-bar color="grey darken-3" dense dark>
            <v-toolbar-title class="overline"
              >{{ selected.length }} selected</v-toolbar-title
            >
            <v-divider class="mx-4" vertical></v-divider>
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="editItem"
              >Update</v-btn
            >
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="deleteOffice"
              >Delete</v-btn
            >
          </v-app-bar>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccessMessage">
        <v-alert dense text type="success" dismissible>
          Added new office
        </v-alert>
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccess">
        <v-alert dense text type="success" dismissible>
          Updated office details
        </v-alert>
      </v-col>
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          show-select
          :headers="headers"
          :items="allOffices"
          class="elevation-2 mt-n6"
          item-key="id"
          :search="search"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand
          @item-expanded="loadDetails"
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.office_group.name`]="{ item }">
            <span
              >{{
                item.office_group == null
                  ? "Not Assigned"
                  : item.office_group.name
              }}
            </span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <v-chip :color="getStatusColor(item.status)" dark>{{
              item.status
            }}</v-chip>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <div style="font-size: 16px">
                      <b class="mr-4">Head User:</b>
                      {{
                        item.users[0]
                          ? `${item.users[0].first_name} ${item.users[0].middle_name} ${item.users[0].last_name}`
                          : "none"
                      }}
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            fab
                            x-small
                            depressed
                            class="ml-4"
                            @click="head_dialog = true"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Change head user</span>
                      </v-tooltip>
                    </div>
                    <h3 class="mt-4">Users assigned to this office:</h3>
                    <br />
                    <table>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Position</th>
                        </tr>
                      </thead>
                      <tbody v-for="user in computedUsersUnder" :key="user.id">
                        <tr>
                          <td>
                            {{ user.first_name }} {{ user.middle_name }}
                            {{ user.last_name }}
                          </td>
                          <td>{{ user.email }}</td>
                          <td>
                            {{
                              user.positions.length > 0
                                ? user.positions[0].name
                                : "none"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-col>
                </v-row>
              </v-container>
            </td>
          </template>
        </v-data-table>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Update Details</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Name*"
                      v-model="editedItem.name"
                      required
                      hint="Make sure it's easy to remember"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Location*"
                      v-model="editedItem.location"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="allOfficeGroups"
                      label="Select Office Group"
                      item-value="id"
                      v-model="editedItem.group_id"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false"
                >Close</v-btn
              >
              <v-btn color="blue darken-1" text @click="save" :disabled="disableSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      "Must select only one office to update details"
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <OfficeCreateModal :dialog="office_dialog" @closeDialog="close" />
    <ChangeHeadUser
      :dialog="head_dialog"
      :users="selectedUsers"
      :office="selectedOffice"
      @closeDialog="close"
    />
    <bulk-user-upload
      :show="bulkUserUpload"
      :card_title="import_user_card"
      @closeDialog="closeBulkUpload"
      :action_for="action_for"
    />
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
  import OfficeCreateModal from "../OfficeCreateModal";
  import ChangeHeadUser from "./ChangeHeadUser";
  import { mapGetters, mapActions } from "vuex";
  import Swal from "sweetalert2";
  import BulkUserUpload from "../imports/ImportModal"
  import LoadingOverlay from "../common/LoadingOverlay.vue";

  export default {
    name: "OfficesList",
    props: {
      tableDisplay: String,
      search: String,
    },
    components: {
      OfficeCreateModal,
      ChangeHeadUser,
      BulkUserUpload,
      LoadingOverlay
    },
    data() {
      return {
        disableSave: false,
        isFetching: false,
        loading: false,
        singleSelect: false,
        showSuccessMessage: false,
        selected: [],
        office_dialog: false,
        head_dialog: false,
        dialog: false,
        errorMessage: null,
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: true,
            value: "name",
          },
          { text: "Group", value: "office_group.name" },
          { text: "Type", value: "type" },
          { text: "Location", value: "location" },
          { text: "Status", value: "status" },
          // { text: "Actions", value: "actions", sortable: false }, //  ACTION COLUMN HEADER IN OFFICES ROUTE
        ],
        editedIndex: -1,
        editedItem: {
          name: "",
          location: "",
          group_id: null,
        },
        options: {
          page: 1,
          itemsPerPage: 5,
        },
        expanded: [],
        singleExpand: true,
        showSuccess: false,
        selectedOffice: null,
        users_under: [],
        snackbar: false,
        timeout: 5000,
        bulkUserUpload: false,
        import_user_card: "Import Offices",
        action_for: "office_imports"
      };
    },
    methods: {
      ...mapActions(["fetchOffices", "updateOffice", "fetchUsersByOffice", "deleteOffices"]),
      getStatusColor(status) {
        if (status === "Active") return "green";
        else return "red";
      },
      deleteOffice() {
         Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          const selectedItems = []
          for (let i = 0; i < this.selected.length; i++) {
            selectedItems.push(this.selected[i].id);
          }
          if(result.isConfirmed){
            this.loading = true
            this.deleteOffices(selectedItems).then((res) => {
              console.log(res)
              if(res.error) {
                this.loading = false
                if(res.status === 403){
                  Swal.fire({
                    icon: "error",
                    title: "Action Forbidden",
                    text:
                      "Cannot delete when a user is assigned with the selected offices"
                  })
                } 
              } else {
                this.loading = false
                Swal.fire(
                  "Deleted!",
                  "Your file has been deleted.",
                  "success"
                );
              }
              this.selected = []
            })
            
          }
        })
      },
      editItem() {
        if (this.selected.length > 1) {
          this.snackbar = true;
          console.log(this.snackbar);
        } else {
          this.editedIndex = this.allOffices.findIndex(
            (office) => office.id == this.selected[0].id
          );
          const selectedOffice = this.allOffices[this.editedIndex];
          this.editedItem = Object.assign({}, selectedOffice);
          this.errorMessage = null;
          this.dialog = true;
        }
      },
      closeBulkUpload(val){
        if(!val) this.bulkUserUpload = false
      },
      close(val) {
        if(val){
          this.showSuccessMessage = true
          this.showSuccess = false
        }
        else
          this.showSuccessMessage = false
    
        this.dialog = false;
        this.office_dialog = false;
        this.head_dialog = false;
        this.errorMessage = null;
        this.selectedOffice = null;
        // this.showSuccess = value ? true : false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
        this.selected = [];
      },
      async save() {
        if (this.editedIndex > -1) {
          this.disableSave = true
          this.loading = true;
          const update = await this.updateOffice(this.editedItem);
          if (update.error) {
            this.loading = false;
            this.disableSave = false
            if (update.status == 400) this.errorMessage = update.message;
            else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Internal Server Error",
              });
            }
          } else if (update) {
            this.disableSave = false
            this.loading = false;
            this.showSuccess = true;
            this.showSuccessMessage = false;
            this.name = "";
            this.location = "";
            this.dialog = false;
            this.errorMessage = null;
            this.close(false);
          }
        }
      },
      loadDetails(item) {
        if (item.value) {
          this.selectedOffice = item.item;
          this.fetchUsersByOffice(item.item).then(() => {
            this.users_under = this.selectedUsers;
          });
        }
      },
    },
    computed: {
      ...mapGetters(["allOffices", "allOfficeGroups", "selectedUsers", "totalOfficeCount"]),
      computedUsersUnder: function() {
        return this.users_under;
      },
    },
    created() {
      if(this.allOffices.length == 0)
        this.isFetching = true
      this.fetchOffices({ itemsPerPage: 0 }).then(() => {
        this.isFetching = false
      });
    },
    watch: {
      tableDisplay: function() {
        this.showSuccess = false;
      },
    },
  };
</script>

<style scoped>
  table {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #4caf50;
    color: white;
  }

  table td,
  table th {
    border: 1px solid #ddd;
    padding: 8px;
  }

  table tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  table tr:hover {
    background-color: #ddd;
  }
</style>
